// @ts-ignore
import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    IconButton,
    CircularProgress,
    useMediaQuery,
    Theme,
    Avatar,
    Typography,
    TextField,
    Button,
} from "@mui/material";
// @ts-ignore
import ChatBackground from "../../Assets/images/others/chat_background.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GroupIcon from "@mui/icons-material/Group";
import SendIcon from "@mui/icons-material/Send";
import { ChatWindowWrapper } from "./ChatWindowWrapper";
import { MessageInput } from "./MessageInput";
import { MessageList } from "./MessageList";
// @ts-ignore
import ChatMessage from "./ChatMessage.tsx";
import { Helper } from "../../tools/Helper";

import { api_Routes } from "../../tools/api_Routes";
import pusher from "../../helper/pusher";
// @ts-ignore
import { SenderInfoPanel } from "./SenderInfoPanel.tsx";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import GroupInfoPanel from "./GroupInfopanel.tsx";
// @ts-ignore
import ChannelInfoPanel from "./ChannelInfopanel.tsx";

const ChatWindow = ({
                        reciverName,
                        reciverImage,
                        setSelectedConversation,
                        messages,
                        currentUser,
                        selectedConversation,
                        loadMoreMessages,
                        isLoadingMore,
                        hasMore,
                        messagesContainerRef,
                        maintainScrollPosition,
                        setMessages,
                        chatType,
                        isLoadingChats,
                    }) => {
    const isMobile = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down("md")
    );

    const navigate = useNavigate();
    const [newMessage, setNewMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [groupInfo, setGroupInfo] = useState<any>(null);
    const [channelInfo, setChannelInfo] = useState<any>(null);
    const [isJoining, setIsJoining] = useState(false);
    const [showInfoPanel, setShowInfoPanel] = useState(false);
    const [LoadingGroupInfo, setIsLoadingGroupInfo] = useState(false);
    const [LoadingChannelInfo, setIsLoadingChannelInfo] = useState(false);
    const [role, setRole] = useState("member");
    const [showGroupInfoPanel, setShowGroupInfoPanel] = useState(false);
    const [showChannelInfoPanel, setShowChannelInfoPanel] = useState(false);
    const [selectedSender, setSelectedSender] = useState<{
        id: number;
        name: string;
        avatar?: string;
    } | null>(null);

    useEffect(() => {
        if (chatType === "group" && selectedConversation) {
            setIsLoadingGroupInfo(true);
            (async () => {
                try {
                    const { response } = await Helper.Get({
                        url: `${api_Routes.UserChat.GroupInfo}?group_id=${selectedConversation}`,
                        hasToken: true,
                    });
                    if (response) setGroupInfo(response.data);
                    setIsLoadingGroupInfo(false);
                } catch (e) {
                    setIsLoadingGroupInfo(false);
                    // console.error(e);
                }
                setIsLoadingGroupInfo(false);
            })();
        }
        if (chatType === "channel" && selectedConversation) {
            setIsLoadingChannelInfo(true);
            (async () => {
                try {
                    const { response } = await Helper.Get({
                        url: `${api_Routes.UserChat.ChannelInfo}?channel_id=${selectedConversation}`,
                        hasToken: true,
                    });
                    if (response) setChannelInfo(response.data);
                    setIsLoadingChannelInfo(false);
                } catch (e) {
                    setIsLoadingChannelInfo(false);
                    console.error(e);
                }
                setIsLoadingChannelInfo(false);
            })();
        }
    }, [selectedConversation, chatType]);

    const handleJoinChannel = async () => {
        setIsJoining(true);
        try {
            const { response } = await Helper.Get({
                url: `${api_Routes.UserChat.JoinChannel}/${currentUser.id}/${selectedConversation}`,
                hasToken: true,
            });
            if (response) setRole("member");
        } catch (error) {
            console.error("Join channel failed:", error);
        } finally {
            setIsJoining(false);
        }
    };

    const handleSendMessage = async () => {
        if (!newMessage.trim() || !selectedConversation) return;
        const tempMessage = {
            id: Date.now(),
            body: newMessage,
            message: newMessage,
            created_at: new Date().toISOString(),
            sender: currentUser,
        };
        setMessages((prev) => [tempMessage, ...prev]);
        setNewMessage("");
        setLoading(true);

        try {
            const url =
                chatType === "individual"
                    ? `${api_Routes.UserChat.SendMessage}?conversation_id=${selectedConversation}&body=${newMessage}`
                    : chatType === "group"
                    ? `${api_Routes.UserChat.SendGroupMessage}/${selectedConversation}?body=${newMessage}`
                    : `${api_Routes.UserChat.SendChannelMessage}/${selectedConversation}?body=${newMessage}`;

            // @ts-ignore
            const { response } = await Helper.Post({ url, hasToken: true });
            if (!response) throw new Error("Failed to send");
        } catch (err) {
            setMessages((prev) => prev.filter((msg) => msg.id !== tempMessage.id));
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const container = messagesContainerRef.current;
        if (!container) return;

        const onScroll = () => {
            if (isLoadingMore || !hasMore) return;
            const { scrollTop, scrollHeight, clientHeight } = container;
            if (scrollHeight - (scrollTop + clientHeight) < 200) loadMoreMessages();
        };

        container.addEventListener("scroll", onScroll);
        return () => container.removeEventListener("scroll", onScroll);
    }, [isLoadingMore, hasMore, loadMoreMessages]);

    useEffect(() => {
        if (!selectedConversation || !currentUser.id) return;

        const channelName =
            chatType === "individual"
                ? `private-chat.${selectedConversation}.${currentUser.id}`
                : chatType === "group"
                ? `private-group.${selectedConversation}`
                : `private-channel.${selectedConversation}`;

        console.log("[Pusher] Subscribing to channel:", channelName);

        const channel = pusher.subscribe(channelName);

        // Listen to connection state changes
        const handleConnectionStateChange = (state: {
            previous: string;
            current: string;
        }) => {
            console.log(
                `[Pusher] Connection state changed: ${state.previous} ➜ ${state.current}`
            );
        };

        const handleSubscriptionSucceeded = () => {
            console.log(`[Pusher] Successfully subscribed to ${channelName}`);
        };

        const handleSubscriptionError = (status: any) => {
            console.error(`[Pusher] Subscription error on ${channelName}:`, status);
        };

        // Attach connection state change listener
        pusher.connection.bind("state_change", handleConnectionStateChange);
        channel.bind("pusher:subscription_succeeded", handleSubscriptionSucceeded);
        channel.bind("pusher:subscription_error", handleSubscriptionError);

        // Message receiving
        const onNew = (data: any) => {
            // console.log("ENTERD");

            const newMsg = {
                id: data.id,
                body: data.body,
                message: data.body,
                created_at: data.created_at,
                sender: data.sender,
            };
            // console.log(newMessage);
            setMessages((prev) => {
                if (
                    prev.some((m) => m.id === newMsg.id) ||
                    newMsg.sender.id === currentUser.id
                )
                    return prev;
                maintainScrollPosition();
                return [newMsg, ...prev];
            });
        };

        const eventName =
            chatType === "individual"
                ? "UserChatMessage"
                : chatType === "group"
                ? "GroupChatMessage"
                : "ChannelChatMessage";

        channel.bind(eventName, onNew);

        return () => {
            // console.log("[Pusher] Unsubscribing from channel:", channelName);
            channel.unbind_all();
            pusher.unsubscribe(channelName);
            pusher.connection.unbind("state_change", handleConnectionStateChange);
        };
    }, [
        selectedConversation,
        currentUser.id,
        chatType,
        setMessages,
        maintainScrollPosition,
    ]);

    const handleOpenInfoPanel = (sender) => {
        setSelectedSender(sender);
        setShowInfoPanel(true);
    };

    const handleCloseInfoPanel = () => setShowInfoPanel(false);

    const handleMessageSender = () => {
        if (!selectedSender) return;
        setSelectedConversation(null);
        navigate(`/chats/individual/${selectedSender.id}`);
        setShowInfoPanel(false);
    };

    useEffect(() => {
        const getrole = async () => {
            if (chatType !== "channel") return;
            try {
                const url = `${api_Routes.UserChat.GetChannelMemberRole}/${currentUser.id}/${selectedConversation}`;
                const { response } = await Helper.Get({ url, hasToken: true });
                if (!response) throw new Error("Failed");
                setRole(response.data);
            } catch (err) {
                console.error(err);
            }
        };
        getrole();
    }, [selectedConversation, currentUser, chatType]);

    if (isLoadingChats || LoadingGroupInfo) {
        return (
            <ChatWindowWrapper>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                    sx={{
                        backgroundImage: `url(${ChatBackground})`,
                        backgroundColor: '#f0f2f5',
                        backgroundSize: 'cover'
                    }}
                >
                    <CircularProgress size={60} thickness={4} sx={{ color: '#3f78e0' }} />
                </Box>
            </ChatWindowWrapper>
        );
    }

    if (!selectedConversation) {
        return (
            <ChatWindowWrapper
                sx={{
                    backgroundImage: `url(${ChatBackground})`,
                    backgroundColor: '#f0f2f5',
                    backgroundSize: 'cover'
                }}
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                    flexDirection="column"
                    gap={2}
                >
                    <Typography variant="h6" color="text.secondary">
                        {chatType === "individual"
                            ? "Select a chat to start messaging"
                            : "Select a group to start messaging"}
                    </Typography>
                </Box>
            </ChatWindowWrapper>
        );
    }

    return (
        <ChatWindowWrapper
            sx={{
                backgroundImage: `url(${ChatBackground})`,
                backgroundColor: '#f0f2f5',
                backgroundSize: 'cover'
            }}
        >
            <Box display="flex" height="100%" width="100%">
                <Box
                    display="flex"
                    flexDirection="column"
                    flexGrow={1}
                    width={showInfoPanel ? "70%" : "100%"}
                    borderRight={showInfoPanel ? "1px solid rgba(0,0,0,0.08)" : "none"}
                >
                    <Box
                        p={2}
                        borderBottom="1px solid rgba(0, 0, 0, 0.08)"
                        display="flex"
                        alignItems="center"
                        gap={2}
                        sx={{
                            backgroundColor: '#ffffff',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                        }}
                    >
                        <IconButton
                            onClick={() => {
                                setSelectedConversation(null);
                                navigate("/chats");
                            }}
                            sx={{ color: '#3f78e0' }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                flexGrow: 1,
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                if (chatType === "group") setShowGroupInfoPanel(true);
                                else if (chatType === "channel") setShowChannelInfoPanel(true);
                                else if (selectedSender) handleOpenInfoPanel(selectedSender);
                            }}
                        >
                            {chatType === "group" ? (
                                <Avatar
                                    src={!LoadingGroupInfo ? groupInfo?.photo : undefined}
                                    sx={{
                                        bgcolor: "#3f78e0",
                                        width: 40,
                                        height: 40,
                                    }}
                                >
                                    <GroupIcon sx={{ color: 'white' }} />
                                </Avatar>
                            ) :chatType === "channel" ? (
                                <Avatar
                                    src={!LoadingGroupInfo ? channelInfo?.photo : undefined}
                                    sx={{
                                        bgcolor: "#3f78e0",
                                        width: 40,
                                        height: 40,
                                    }}
                                >
                                    <GroupIcon sx={{ color: 'white' }} />
                                </Avatar>
                            ): (
                                <Avatar
                                    src={reciverImage ? reciverImage : undefined}
                                    sx={{
                                        bgcolor: '#3f78e0',
                                        width: 40,
                                        height: 40,
                                    }}>
                                    {reciverName ? reciverName[0] : ''}
                                </Avatar>
                            )}
                            <Box>
                                <Typography variant="h6" fontWeight={600} color="#333">
                                    {chatType === "group"
                                        ? groupInfo?.name || "Group Chat"
                                        : chatType === "individual"
                                            ? reciverName || "Chat"
                                            :channelInfo?.name ||"Channel"}
                                </Typography>
                                {chatType === "group" && groupInfo?.members && (
                                    <Typography variant="caption" color="#666">
                                        {groupInfo.members.length} members
                                    </Typography>
                                )}
                                {chatType === "channel" && channelInfo?.members && (
                                    <Typography variant="caption" color="text.secondary">
                                        {channelInfo.members.length} members
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Box>

                    {isLoadingMore && (
                        <Box display="flex" justifyContent="center" py={1}>
                            <CircularProgress size={24} sx={{ color: '#3f78e0' }} />
                        </Box>
                    )}

                    <MessageList
                        ref={messagesContainerRef}
                        sx={{
                            display: "flex",
                            flexDirection: "column-reverse",
                            overflowY: "auto",
                            overflowX: "hidden",
                            height: "calc(100vh - 160px)",
                            position: "relative",
                            background: 'transparent',
                            padding: '8px 0',
                            '&::-webkit-scrollbar': {
                                width: '6px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: 'rgba(63, 120, 224, 0.3)',
                                borderRadius: '3px',
                            },
                            '&::-webkit-scrollbar-track': {
                                backgroundColor: 'rgba(63, 120, 224, 0.1)',
                            }
                        }}
                    >
                        {messages.length === 0 && (
                            <Box
                                position="absolute"
                                top="50%"
                                left="50%"
                                sx={{
                                    transform: "translate(-50%, -50%)",
                                    textAlign: "center",
                                    width: "100%",
                                    px: 2,
                                }}
                            >
                                <Box
                                    sx={{
                                        background: "transparent",
                                        width : isMobile ? '90%' : '50%',
                                        justifySelf : 'center',
                                        borderRadius: 20,
                                        p: 2,
                                        backdropFilter: "blur(4px)",
                                        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        color="text.secondary"
                                        sx={{ fontStyle: "italic" }}
                                    >
                                        {chatType !== "channel" &&
                                        "Send a message to start the conversation!"}
                                        {chatType === "channel" && "There is No Messages Posted Yet!"}
                                    </Typography>
                                </Box>
                            </Box>
                        )}

                        {messages.map((msg) => (
                            <ChatMessage
                                key={msg.id}
                                message={msg}
                                currentUserId={currentUser.id}
                                chatType={chatType}
                                onOpenInfo={handleOpenInfoPanel}
                            />
                        ))}
                        <div ref={messagesContainerRef} />
                    </MessageList>

                    {chatType !== "channel" || role === "admin" || role === "owner" ? (
                    <MessageInput sx={{
                        bgcolor: 'transparent',
                        width: isMobile ? '90%':'70%',
                        alignSelf: 'center',
                        borderTop: '1px solid rgba(0,0,0,0.08)',
                        padding: '8px 16px',
                        borderRadius: 0,
                    }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder={`Type a message${
                                chatType === "group" ? " to group" : ""
                            }...`}
                            value={newMessage}
                            onChange={(e) => setNewMessage(e.target.value)}
                            onKeyPress={(e) =>
                                e.key === "Enter" && !loading && handleSendMessage()
                            }
                            size="small"
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: 20,
                                    backgroundColor: 'rgba(240, 242, 245, 0.9)',
                                    "& fieldset": {
                                        border: 'none',
                                    },
                                    "&:hover fieldset": {
                                        border: 'none',
                                    },
                                    "&.Mui-focused fieldset": {
                                        border: 'none',
                                        boxShadow: '0 0 0 2px rgba(63, 120, 224, 0.2)',
                                    },
                                },
                                "& .MuiOutlinedInput-input": {
                                    padding: '10px 16px',
                                    fontSize: '0.95rem',
                                }
                            }}
                        />
                        <IconButton
                            onClick={handleSendMessage}
                            disabled={loading || !newMessage.trim()}
                            sx={{
                                backgroundColor: '#3f78e0',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#2d68d0'
                                },
                                marginLeft: 1,
                                width: 40,
                                height: 40,
                                transition: 'background-color 0.3s, color 0.3s',

                                // Override disabled state styles
                                '&.Mui-disabled': {
                                    backgroundColor: '#3f78e055',
                                    color: '#ffffff',
                                }
                            }}
                        >
                            {loading ? (
                                <CircularProgress
                                    size={20}
                                    color="inherit"
                                    sx={{ color: 'inherit' }}
                                />
                            ) : (
                                <SendIcon
                                    fontSize="small"
                                    sx={{ color: 'inherit',
                                        marginLeft:'1px'
                                    }}
                                />
                            )}
                        </IconButton>
                    </MessageInput> ):role === "Not A Member" ? (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                py: 2,
                                borderTop: "1px solid",
                                borderColor: "divider",
                            }}
                        >
                            <Button
                                variant="contained"
                                onClick={handleJoinChannel}
                                disabled={isJoining}
                                startIcon={isJoining ? <CircularProgress size={16} /> : null}
                                sx={{
                                    borderRadius: 24,
                                    px: 3,
                                    textTransform: "none",
                                    fontWeight: "medium",
                                }}
                            >
                                {isJoining ? "Joining..." : "Join Channel"}
                            </Button>
                        </Box>
                    ) : null}
                </Box>

                {showInfoPanel && !isMobile && selectedSender && (
                    <Box
                        sx={{
                            width: "30%",
                            height: "100%",
                            overflowY: "auto",
                            borderLeft: "1px solid rgba(0,0,0,0.08)",
                            backgroundColor: '#f8f9fa',
                        }}
                    >
                        <SenderInfoPanel
                            sender={selectedSender}
                            onClose={handleCloseInfoPanel}
                            onMessageClick={handleMessageSender}
                            chatType={chatType}
                            isDesktop
                        />
                    </Box>
                )}
                {showGroupInfoPanel && !isMobile && groupInfo && (
                    <Box
                        sx={{
                            width: "30%",
                            height: "100%",
                            overflowY: "auto",
                            borderLeft: "1px solid rgba(0,0,0,0.08)",
                            backgroundColor: '#f8f9fa',
                        }}
                    >
                        <GroupInfoPanel
                            groupInfo={groupInfo}
                            onClose={() => setShowGroupInfoPanel(false)}
                            isDesktop
                        />
                    </Box>
                )}
                {showChannelInfoPanel && !isMobile && channelInfo && (
                    <Box
                        sx={{
                            width: "30%",
                            height: "100%",
                            overflowY: "auto",
                            borderLeft: "1px solid rgba(0,0,0,0.12)",
                        }}
                    >
                        <ChannelInfoPanel
                            channelInfo={channelInfo}
                            onClose={() => setShowChannelInfoPanel(false)}
                            isDesktop
                        />
                    </Box>
                )}
            </Box>

            {showInfoPanel && isMobile && selectedSender && (
                <SenderInfoPanel
                    sender={selectedSender}
                    onClose={handleCloseInfoPanel}
                    onMessageClick={handleMessageSender}
                    chatType={chatType}
                    isDesktop={false}
                />
            )}
            {showGroupInfoPanel && isMobile && groupInfo && (
                <GroupInfoPanel
                    groupInfo={groupInfo}
                    onClose={() => setShowGroupInfoPanel(false)}
                    isDesktop={false}
                />
            )}
            {showChannelInfoPanel && isMobile && channelInfo && (
                <ChannelInfoPanel
                    channelInfo={channelInfo}
                    onClose={() => setShowChannelInfoPanel(false)}
                    isDesktop={false}
                    isAdmin={role === "admin" || role === "owner"}
                />
            )}
        </ChatWindowWrapper>
    );
};

export default ChatWindow;